import * as React from 'react';
import _ from 'lodash';
import { Select } from 'mkui-fd';
import { getSelectValue, getSelectObject } from './util';
import { propTypes, defaultProps } from './PropTypes';

const Option = Select.Option;

export default class EnhancedSelect extends React.Component {
  /** *******************life cycle************************** */
  constructor(props) {
    super(props);

    const { dataSource, api } = this.props;
    this.state = {
      loading: true,
      dataSource: api ? [] : dataSource,
      isApiLoaded: false,
    };
  }

  static getDerivedStateFromProps(props) {
    const { multiple, param, value, api, disabled } = props;
    return {
      param,
      value: multiple ? value : [value],
      api,
      disabled,
    };
  }

  componentDidMount() {
    // const { disabled, value } = this.state;
    // if (!disabled) {
    //   this.fetch();
    // } else {
    //   this.setDataSource(value);
    // }

    this.fetch();
  }

  componentDidUpdate(prevProps) {
    const { param: prevParam, dataSource: prevDataSource, disabled: prevDisabled } = prevProps;
    const { param, dataSource, disabled } = this.props;
    const { isApiLoaded } = this.state;

    if (!_.isEqual(prevParam, param)) {
      this.fetch();
    }

    if (!_.isEqual(prevDataSource, dataSource)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        dataSource,
      });
    }

    if (disabled !== prevDisabled && !disabled && !isApiLoaded) {
      this.fetch();
    }
  }

  /** *******************handle method************************** */
  selectHandle = (value) => {
    const { onChange, multiple } = this.props;
    const { dataSource } = this.state;
    const newValue = getSelectObject(value, dataSource, multiple);
    onChange(newValue);
  }

  /** *******************inner method************************** */
  fetch = async () => {
    const { api, param, dataSource } = this.state;
    const data = api ? await api({ ...param }) : dataSource;

    this.setState({
      dataSource: data,
      loading: false,
      isApiLoaded: true,
    });
  }

  /** *******************render method************************** */
  getRenderContext = (dataSource) => dataSource.map((d) => <Option key={d.code}>{d.name}</Option>)

  render() {
    const { dataSource, loading, value, disabled } = this.state;
    const { multiple } = this.props;

    return (
      <Select
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        loading={loading}
        disabled={disabled}
        onChange={this.selectHandle}
        value={getSelectValue(multiple, value, dataSource)}
        mode={multiple && 'multiple'}
      >
        {
          this.getRenderContext(dataSource)
        }
      </Select>
    );
  }
}

EnhancedSelect.propTypes = propTypes;
EnhancedSelect.defaultProps = defaultProps;
